var Sizes = ['xlarge', 'large', 'medium', 'small', 'xsmall'];
var colorValues = [
    'black',
    'blue',
    'blue-green',
    'green',
    'green-light',
    'red',
    'orange',
    'yellow',
    'gray',
    'gray-dark',
    'gray-darker',
    'white',
    'yellow-dark',
];
export var isColor = function (value) { return colorValues.includes(value); };
export var isSize = function (value) { return Sizes.includes(value); };
